import type { FilterField } from "../types";
import { BooleanFilter } from "../widgets/boolean-filter";
import { DateRangeFilter } from "../widgets/date-range-filter";
import { EntityFilter } from "../widgets/entity-filter";
import { MultiEntityFilter } from "../widgets/multi-entity-filter";
import { MultiSelectFilter } from "../widgets/multi-select-filter";
import { PriceRangeFilter } from "../widgets/price-range-filter";
import { SingleSelectFilter } from "../widgets/single-select-filter";

/**
 * Dispatches a `FilterField` to its widget. A field may supply a custom
 * `render` (escape hatch) — used instead of the type's generic widget.
 */
export const ActiveFilter = ({ field }: { field: FilterField }) => {
  if (field.render) return field.render(field);

  switch (field.type) {
    case "multiSelect":
      return <MultiSelectFilter field={field} />;
    case "singleSelect":
      return <SingleSelectFilter field={field} />;
    case "dateRange":
      return <DateRangeFilter field={field} />;
    case "priceRange":
      return <PriceRangeFilter field={field} />;
    case "boolean":
      return <BooleanFilter field={field} />;
    case "entity":
      return <EntityFilter field={field} />;
    case "multiEntity":
      return <MultiEntityFilter field={field} />;
    default:
      return null;
  }
};
